import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'broadcastFlows/senders';
var crud = createCrud(basePath);

/* Default queries */
export var useBroadcastFlowSenderCount = crud.makeCount();
export var useBroadcastFlowSenderById = crud.makeFindById();
export var useBroadcastFlowSenderByIds = crud.makeFindByIds();
export var useBroadcastFlowSenderMany = crud.makeFindMany();
export var useBroadcastFlowSenderOne = crud.makeFindOne();
export var useBroadcastFlowSenderPagination = crud.makePagination();

/* Default mutations */
export var useBroadcastFlowSenderCreateOne = crud.makeCreateOne();
export var useBroadcastFlowSenderUpdateOne = crud.makeUpdateOne();
export var useBroadcastFlowSenderRemoveById = crud.makeRemoveById();

/* Custom queries */

/* Custom mutations */